
import {
    defineComponent,
    ref,
    onMounted,
    reactive,
    inject
} from 'vue'

//components
import Drawer1 from "@/views/persons/ParticipationDetails.vue"

//services
import personService from "@/core/services/PersonService"
import {
    errManager
} from "@/core/config/Tools";

export default defineComponent({
    name: "TableHistory",
    props: {
        idperson: {
            type: String,
            required: true,
            default: ""
        }
    },
    components: {
        Drawer1
    },
    setup(props) {
        const loader = ref(false)
        const listHistory = ref([])
        const selectedRow = ref < any > ({});
        const gblDrawer1 = inject < any > ('gblDrawer1')

        const getHistory = async () => {
            loader.value = true
            listHistory.value.length = 0
            personService.getHistorial(props.idperson)
                .then((res) => {
                    listHistory.value = res.data
                    loader.value = false
                }).catch(({
                    response
                }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const handleRowClick = (row) => {
            selectedRow.value = row;
            gblDrawer1.value = true
        };

        onMounted(() => {
            getHistory()

        })

        return {
            loader,
            listHistory,
            getHistory,
            selectedRow,
            handleRowClick
        }

    },
})
